import {useMapContext} from '../context'
import {MapRef} from '../types'

export const useMapRef = (): MapRef | undefined => {
  const mapContext = useMapContext()
  if (!mapContext.mapRef) {
    return
  }
  return mapContext.mapRef
}
